/* TSC chrome — dropdowns, drill-down drawer, rotating announcement.
   Deferred, no dependencies. Degrades cleanly: with JS off, menu links still
   work, the desktop nav is unaffected, and the first announcement is visible. */
(function () {
  'use strict';


  /* reveal on scroll — adds .tsc-js to <html> first, so the CSS only hides
     content once we know the script is running. Never hides it otherwise. */
  document.documentElement.classList.add('tsc-js');
  var rv = document.querySelectorAll('.tsc-rv');
  if (rv.length) {
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e, n) {
          if (!e.isIntersecting) return;
          setTimeout(function () { e.target.classList.add('tsc-in'); }, n * 55);
          io.unobserve(e.target);
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -40px' });
      rv.forEach(function (el) { io.observe(el); });
    } else {
      rv.forEach(function (el) { el.classList.add('tsc-in'); });
    }
  }

  /* rotating announcement */
  var bar = document.querySelector('.tsc-ann[data-rotate]');
  if (bar && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var msgs = bar.querySelectorAll('.tsc-ann__m');
    if (msgs.length > 1) {
      var i = 0, ms = (parseInt(bar.dataset.rotate, 10) || 5) * 1000;
      setInterval(function () {
        msgs[i].classList.remove('is-on');
        i = (i + 1) % msgs.length;
        msgs[i].classList.add('is-on');
      }, ms);
    }
  }

  /* desktop dropdowns */
  var hd = document.getElementById('tsc-hd'), t;
  function closeMega() {
    document.querySelectorAll('.tsc-mega.is-open').forEach(function (m) { m.classList.remove('is-open'); });
    document.querySelectorAll('.tsc-navi.is-open').forEach(function (n) {
      n.classList.remove('is-open');
      var a = n.querySelector('.tsc-navl');
      if (a && a.hasAttribute('aria-expanded')) a.setAttribute('aria-expanded', 'false');
    });
  }
  function openMega(item) {
    var p = document.querySelector('.tsc-mega[data-mega-panel="' + item.dataset.mega + '"]');
    if (!p) return;
    closeMega();
    p.classList.add('is-open');
    item.classList.add('is-open');
    var a = item.querySelector('.tsc-navl');
    if (a && a.hasAttribute('aria-expanded')) a.setAttribute('aria-expanded', 'true');
  }
  document.querySelectorAll('.tsc-navi.has-mega').forEach(function (item) {
    item.addEventListener('mouseenter', function () { clearTimeout(t); openMega(item); });
    var l = item.querySelector('.tsc-navl');
    if (l) l.addEventListener('focus', function () { openMega(item); });
  });
  document.querySelectorAll('.tsc-navi:not(.has-mega)').forEach(function (i) {
    i.addEventListener('mouseenter', closeMega);
  });
  if (hd) {
    hd.addEventListener('mouseleave', function () { t = setTimeout(closeMega, 140); });
    hd.addEventListener('mouseenter', function () { clearTimeout(t); });
  }

  /* drill-down drawer */
  var dw = document.getElementById('tsc-drawer'),
      scrim = document.getElementById('tsc-scrim'),
      burger = document.getElementById('tsc-burger'),
      closeBtn = document.getElementById('tsc-dw-close'),
      trail = ['root'];

  function showPanel(id) {
    document.querySelectorAll('.tsc-pnl').forEach(function (p) { p.classList.remove('is-on', 'is-behind'); });
    var cur = document.querySelector('.tsc-pnl[data-panel="' + id + '"]');
    if (cur) { cur.classList.add('is-on'); cur.scrollTop = 0; }
    if (trail.length > 1) {
      var prev = document.querySelector('.tsc-pnl[data-panel="' + trail[trail.length - 2] + '"]');
      if (prev) prev.classList.add('is-behind');
    }
  }
  function openDrawer() {
    if (!dw) return;
    dw.classList.add('is-on');
    dw.setAttribute('aria-hidden', 'false');
    if (scrim) { scrim.hidden = false; requestAnimationFrame(function () { scrim.classList.add('is-on'); }); }
    if (burger) burger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    if (closeBtn) closeBtn.focus();
  }
  function closeDrawer() {
    if (!dw) return;
    dw.classList.remove('is-on');
    dw.setAttribute('aria-hidden', 'true');
    if (scrim) scrim.classList.remove('is-on');
    if (burger) { burger.setAttribute('aria-expanded', 'false'); burger.focus(); }
    document.body.style.overflow = '';
    setTimeout(function () {
      if (scrim) scrim.hidden = true;
      trail = ['root'];
      showPanel('root');
    }, 280);
  }
  if (burger) burger.addEventListener('click', openDrawer);
  if (scrim) scrim.addEventListener('click', closeDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);

  document.addEventListener('click', function (e) {
    var go = e.target.closest('[data-go]');
    if (go) { trail.push(go.dataset.go); showPanel(go.dataset.go); return; }
    var back = e.target.closest('[data-back]');
    if (back) { trail.pop(); showPanel(trail[trail.length - 1]); return; }
    if (hd && !hd.contains(e.target)) closeMega();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeMega(); closeDrawer(); }
  });

  /* keep the theme editor sane */
  document.addEventListener('shopify:section:load', function (e) {
    trail = ['root'];
    var els = (e.target || document).querySelectorAll('.tsc-rv');
    els.forEach(function (el) { el.classList.add('tsc-in'); });
  });
}());